/** Contato público da Astra (rodapé, cadastro, fatura no painel). */
export const SITE_CONTACT_EMAIL = "contato@astraenergia.com.br"
export const SITE_CONTACT_PHONE_DISPLAY = "(31) 3193-1106"
/** E.164 para schema.org, links tel: e integrações. */
export const SITE_CONTACT_PHONE_E164 = "+553131931106"

/** WhatsApp de atendimento ao cliente (site e painel). */
export const SITE_SUPPORT_WHATSAPP_DISPLAY = "(31) 2391-6665"
export const SITE_SUPPORT_WHATSAPP_E164 = "+553123916665"

/** Razão social da líder (rodapé, schema LocalBusiness). */
export const SITE_LEGAL_NAME = "ASTRA GESTAO DE ENERGIA LTDA"
export const SITE_CNPJ_DISPLAY = "65.022.917/0001-32"

/**
 * Endereço público (NAP) — alinhado ao rodapé (sem sala).
 * Usado em LocalBusiness / Organization.
 */
export const SITE_BUSINESS_ADDRESS = {
  streetAddress: "Rua Monte Alegre, 49",
  addressLocality: "Belo Horizonte",
  addressRegion: "MG",
  postalCode: "30240-230",
  addressCountry: "BR",
} as const

/** Linha única exibida no rodapé e em textos legais curtos (mesma NAP do schema). */
export const SITE_BUSINESS_ADDRESS_DISPLAY =
  "Rua Monte Alegre, 49, Serra, Belo Horizonte/MG, CEP 30.240-230"

/** Emitente da fatura de energia (consórcio de geração compartilhada). */
export const CONSORTIUM_LEGAL_NAME = "CONSÓRCIO ASTRA GERAÇÃO COMPARTILHADA"
export const CONSORTIUM_CNPJ = "65.570.751/0001-99"

/** Nomes públicos aprovados para o site (não são a razão social em caixa alta da fatura). */
export const CONSORTIUM_PUBLIC_NAME = "Consórcio Astra Geração Compartilhada"
export const SITE_MANAGER_PUBLIC_NAME = "Astra Gestão de Energia LTDA"

/** Rodapé, /termos e /sobre. */
export const ENERGY_CREDITS_LEGAL_LINE =
  `Créditos gerados pelo ${CONSORTIUM_PUBLIC_NAME} (CNPJ ${CONSORTIUM_CNPJ}), administrado pela ${SITE_MANAGER_PUBLIC_NAME} (CNPJ ${SITE_CNPJ_DISPLAY})`

/** FAQ “como funciona” e “é legal?”. */
export const CONSORTIUM_MEMBER_SENTENCE =
  `Ao aderir, você vira consorciado do ${CONSORTIUM_PUBLIC_NAME} (CNPJ ${CONSORTIUM_CNPJ}).`

/** A Astra Solar não é a marca que atende o consumidor final. */
export const ASTRA_SOLAR_NOT_RETAIL_SENTENCE =
  "A Astra Solar é outra empresa do grupo e não atende consumidor final."
export const CONSORTIUM_ADDRESS =
  "Rua Monte Alegre, 49, sala 504-C — Serra, Belo Horizonte - MG, 30.240-230"

export const FATURA_ISSUER_COMPANY = {
  name: CONSORTIUM_LEGAL_NAME,
  cnpj: CONSORTIUM_CNPJ,
  address: CONSORTIUM_ADDRESS,
  contactEmail: SITE_CONTACT_EMAIL,
  contactPhone: SITE_CONTACT_PHONE_DISPLAY,
} as const
